




















































































































































































import { Component, Vue } from "vue-property-decorator";
import store from "../store";
import Axios from "axios";
import { Rest, Product, PayOpt, NfProduct, PayMethod, Nfce } from "../types";
import { toBrl, fromBrl, fromPoster } from "../helpers";

@Component
export default class Home extends Vue {
  model = {
    client: { name: "", cpf: "", cnpj: "" },
    rest: { id: "" },
    mini: { product: "", product_price: "", num: "" },
    sum: { des: "" },
    pay: {
      method: { label: "", value: null },
      flag: { label: "", value: null },
      value: ""
    },
    payOpts: {
      methods: [
        { label: "Dinheiro", value: "01" },
        { label: "Cheque", value: "02" },
        { label: "Credito", value: "03" },
        { label: "Debito", value: "04" },
        { label: "PIX", value: "17" }
      ],
      flags: [
        { label: "", value: null },
        { label: "Visa", value: "01" },
        { label: "Master", value: "02" },
        { label: "Amex", value: "03" },
        { label: "Socred", value: "04" },
        { label: "Outros", value: "99" }
      ]
    },
    disabled: false,
    emmitDisabled: true
  };
  rest: Array<Rest> = [];
  pay: Array<PayOpt> = [];
  products = [{ value: "", product_name: "" }];

  get subTotal() {
    return toBrl(
      this.rest.reduce(
        (acc, e) => (acc += fromBrl(e.total_price) + fromBrl(e.tip_sum)),
        0
      )
    );
  }

  get payment() {
    let sum = 0;
    this.pay.forEach(e => {
      sum += fromBrl(e.value);
    });
    return toBrl(sum);
  }

  get left() {
    return toBrl(
      fromBrl(this.subTotal) -
        fromBrl(this.model.sum.des) -
        fromBrl(this.payment)
    );
  }

  updated() {
    this.model.emmitDisabled = this.model.disabled || 0 != fromBrl(this.left);
  }

  mounted() {
    Axios.get(`https://api.clubdobalanco.com/v1/taxes`, {
      headers: { Authorization: store.state.passwd }
    }).then(
      r =>
        (this.products = (r.data as [
          { value: string; product_name: string }
        ]).map(e => {
          e.value = e.product_name;
          return e;
        }))
    );
  }

  querySearch(queryString: string, cb: Function) {
    var links = this.products;
    var results = queryString
      ? links.filter(
          v =>
            v.value
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase()
              .indexOf(
                queryString
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
              ) === 0
        )
      : links;
    // call callback function to return suggestions
    cb(results);
  }

  async getPoster() {
    this.model.disabled = true;
    let id = this.model.rest.id;
    let data = await Axios.get(`https://api.clubdobalanco.com/v1/table/${id}`, {
      headers: { Authorization: store.state.passwd }
    });

    let tickets = data.data as Array<Rest>;

    //formating
    let okList: Array<string> = [];
    tickets.forEach(e => {
      this.rest.push({
        ...e,
        payed_card: toBrl(e.payed_card),
        payed_cash: toBrl(e.payed_cash),
        tip_sum: toBrl(e.tip_sum),
        products: e.products.map(p => ({
          ...p,
          product_price: toBrl(p.product_price)
        })),
        total_price: toBrl(
          e.products.reduce((acc, x) => (acc += Number(x.product_price)), 0)
        )
      });

      okList.push(e.transaction_id.toString());
    });

    //submitting errors
    let errorList = id.split(",").filter(e => !okList.includes(e));
    console.log(errorList);
    if (errorList.length == 0) {
      this.$notify({
        title: "Sucesso",
        message: "",
        type: "success"
      });
    } else {
      this.$notify.error({
        title: "Algumas comandas não foram encontradas",
        message: errorList.toString()
      });
    }

    this.model.disabled = false;
  }

  async getProduct() {
    this.model.disabled = true;

    try {
      let r = await Axios.get(
        `https://api.clubdobalanco.com/v1/tax/${this.model.mini.product}`,
        { headers: { Authorization: store.state.passwd } }
      );
      let product: Product = r.data;
      product.num = Number(this.model.mini.num);

      //removing float format because js
      product.product_price = toBrl(
        fromBrl(this.model.mini.product_price) * product.num
      );

      let index = this.rest.findIndex(e => {
        return e.transaction_id == "Frigobar";
      });

      if (index !== -1) {
        let total =
          fromBrl(this.rest[index].payed_cash) + fromBrl(product.product_price);
        this.rest[index].products.push(product);
        this.rest[index].payed_cash = toBrl(total);
        this.rest[index].total_price = toBrl(total);
      } else {
        this.rest.push({
          transaction_id: "Frigobar",
          transaction_comment: "Frigobar",
          payed_card: "0,00",
          payed_cash: product.product_price,
          tip_sum: "0,00",
          discount: 0,
          products: [product],
          total_price: product.product_price
        });
      }
    } catch (err) {
      this.$notify.error({
        title: "Produto não encontrado",
        message: "verifque a ortografia"
      });
    }

    this.model.disabled = false;
  }

  async send() {
    this.model.disabled = true;

    //formating...
    let items: Array<NfProduct> = this.rest.flatMap(e => {
      return fromPoster(e);
    });

    //discount (ignoring tips)
    let subTotal = this.rest.reduce(
      (acc, e) => (acc += fromBrl(e.total_price)),
      0
    );
    let pdes = (100 * fromBrl(this.model.sum.des)) / subTotal;
    let remaining = fromBrl(this.model.sum.des);

    items.forEach((e, i, arr) => {
      e.numero_item = i + 2;
      let des = Math.round(pdes * e.valor_bruto);
      e.valor_desconto = (arr.length == i + 1 ? remaining : des) / 100;
      remaining -= des;
    });

    //tip
    let tip = this.rest.reduce((acc, e) => {
      return acc + fromBrl(e.tip_sum);
    }, 0);

    if (tip > 0)
      items.push({
        numero_item: 1,
        codigo_produto: 6969,
        descricao: "Gorjeta",
        valor_desconto: 0,
        quantidade_comercial: 1,
        quantidade_tributavel: 1,
        valor_unitario_comercial: tip / 100,
        valor_unitario_tributavel: tip / 100,
        valor_bruto: tip / 100,
        cfop: 5101,
        codigo_ncm: "00000000",
        icms_situacao_tributaria: 40,
        unidade_comercial: "un",
        icms_origem: 0,
        unidade_tributavel: "un",
        pis_situacao_tributaria: 8,
        cofins_situacao_tributaria: 8,
        icms_modalidade_base_calculo: 0,
      });

    //payment..
    let pay: Array<PayMethod> = [];
    this.pay.forEach(e =>
      pay.push({
        bandeira_operadora: e.flag.value,
        forma_pagamento: e.method.value,
        valor_pagamento: fromBrl(e.value) / 100
      })
    );

    //more formating
    var data: Nfce = {
        natureza_operacao: "VENDA AO CONSUMIDOR",
        data_emissao: new Date(),
        presenca_comprador: 1,
        cnpj_emitente: "00987902000163",
        nome_destinatario: this.model.client.name,
        cpf_destinatario: this.model.client.cpf,
        cnpj_destinatario: this.model.client.cnpj ,
        items: items,
        formas_pagamento: pay,
        modalidade_frete: 9,
        valor_desconto:
        items.reduce((acc, e) => {
            return (acc += e.valor_desconto * 100);
        }, 0) / 100
    };

    console.log(data);
    const h = this.$createElement;

    try {
      let r = await Axios.post("https://api.clubdobalanco.com/v1/nfce", data, {
        headers: { Authorization: store.state.passwd }
      });
      if (r.data.status == "autorizado") {
        this.clear();
        this.$notify({
          title: "Nota Emitida",
          message: h("a", `https://api.focusnfe.com.br${r.data.caminho_danfe}`),
          type: "success"
        });
      } else {
        this.$notify({
          title: "Rejeitado pela SEFAZ",
          message: r.data.mensagem_sefaz,
          type: "warning"
        });
      }
    } catch (err) {
      this.$notify.error({
        title: "Algo deu errado",
        message: err
      });
    }

    this.model.disabled = false;
  }

  clear() {
    this.model = {
      client: { name: "", cpf: "", cnpj: "" },
      rest: { id: "" },
      mini: { product: "", product_price: "", num: "" },
      sum: { des: "" },
      pay: {
        method: { label: "", value: null },
        flag: { label: "", value: null },
        value: ""
      },
      payOpts: {
        methods: [
          { label: "Dinheiro", value: "01" },
          { label: "Cheque", value: "02" },
          { label: "Credito", value: "03" },
          { label: "Debito", value: "04" },
          { label: "PIX", value: "17" }
        ],
        flags: [
          { label: "", value: null },
          { label: "Visa", value: "01" },
          { label: "Master", value: "02" },
          { label: "Amex", value: "03" },
          { label: "Socred", value: "04" },
          { label: "Outros", value: "99" }
        ]
      },
      disabled: false,
      emmitDisabled: true
    };
    this.rest = [];
    this.pay = [];
  }
}
